import { useLocalPageData } from 'src/app/pages/local/pageContext';

type Result = ModelHookResult<{
	displayName: string;
	location?: {
		lat: number;
		lng: number;
	};
}>;

export function usePageHeading(): Result {
	const {
		data: { displayName, lat, lng },
	} = useLocalPageData();

	return {
		data: {
			displayName,
			location: lat && lng ? { lat, lng } : undefined,
		},
	};
}
